import paths from '@/routes/paths';

export type menuListType = {
	id: number;
	label: string;
	path: string;
	subMenu?: { id: number; label: string; path: string }[];
};
export const menuList: menuListType[] = [
	{
		id: 1,
		label: '미스터디벨로 소개',
		path: '/intro',
		subMenu: [
			{
				id: 101,
				label: '철학',
				path: paths.intro.philosophy
			},
			{ id: 103, label: '턴키 개발이란', path: paths.intro.turnKey }
		]
	},
	{ id: 2, label: '포트폴리오', path: paths.portfolio },
	{
		id: 3,
		label: '컨텐츠',
		path: '/content',
		subMenu: [
			{ id: 301, label: '블로그', path: paths.content.blog },
			{ id: 302, label: '유튜브', path: paths.content.youtube }
		]
	},
	{ id: 5, label: 'FAQ', path: paths.faq }
];
